import { EventEmitter } from '@unimodules/core';

export const LocationEventEmitter = new EventEmitter({} as any);
